import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  /* Import Inter font */
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

  * {
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
  }

  /* Apply to all elements */
  *, *::before, *::after {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  }

  /* Headings */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
    font-weight: 600 !important;
  }

  /* Ant Design overrides */
  .ant-app,
  .ant-typography,
  .ant-btn,
  .ant-input,
  .ant-input-number,
  .ant-select,
  .ant-table,
  .ant-menu,
  .ant-form-item-label,
  .ant-card,
  .ant-modal,
  .ant-message,
  .ant-notification,
  .ant-drawer,
  .ant-dropdown,
  .ant-tooltip,
  .ant-popover,
  .ant-date-picker,
  .ant-time-picker,
  .ant-steps,
  .ant-progress,
  .ant-tag,
  .ant-badge,
  .ant-alert,
  .ant-breadcrumb,
  .ant-pagination,
  .ant-tabs,
  .ant-layout,
  .ant-layout-header,
  .ant-layout-content,
  .ant-layout-footer,
  .ant-layout-sider {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  }

  /* Specific Ant Design text elements */
  .ant-select-selection-item,
  .ant-select-selection-placeholder,
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-form-item-label > label,
  .ant-btn span,
  .ant-menu-item,
  .ant-typography h1,
  .ant-typography h2,
  .ant-typography h3,
  .ant-typography h4,
  .ant-typography h5,
  .ant-typography h6,
  .ant-typography p,
  .ant-typography div,
  .ant-typography span {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  }
`;